var installedModules = {};
var moduleToHandlerMapping = {
	1961: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_Subscriber_js"), __webpack_require__.e("default-node_modules_angular_core_fesm2022_effect_mjs"), __webpack_require__.e("default-node_modules_angular_core_fesm2022_resource_mjs"), __webpack_require__.e("common"), __webpack_require__.e("node_modules_rxjs_dist_esm_internal_BehaviorSubject_js-node_modules_angular_core_fesm2022_core_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/core */ 310))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^20.3.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core",
	},
	1653: {
		getter: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 2935))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^20.3.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/primitives/signals",
	},
	6077: {
		getter: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 8757))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^20.3.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/primitives/di",
	},
	4963: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_Subscriber_js"), __webpack_require__.e("default-node_modules_angular_common_fesm2022_common_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/common */ 1142))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^20.3.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/common",
	},
	4100: {
		getter: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @kaercher/shared-core */ 4039))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@kaercher/shared-core",
	},
	8828: {
		getter: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @kaercher/payment-methods-core */ 449))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@kaercher/payment-methods-core",
	},
	4204: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_Subscriber_js"), __webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_observable_innerFrom_js-node_modules_rxjs_dist_es-f32a11"), __webpack_require__.e("default-node_modules_ngx-translate_core_dist_fesm2022_ngx-translate-core_mjs"), __webpack_require__.e("default-node_modules_angular_forms_fesm2022_forms_mjs"), __webpack_require__.e("default-libs_offline_ui_src_index_ts-node_modules_rxjs_dist_esm_internal_Subject_js-node_modu-c8974c")]).then(() => (() => (__webpack_require__(/*! @kaercher/offline-ui */ 866))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@kaercher/offline-ui",
	},
	917: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_angular_core_fesm2022_effect_mjs"), __webpack_require__.e("default-node_modules_angular_core_fesm2022_resource_mjs"), __webpack_require__.e("default-node_modules_angular_core_fesm2022_rxjs-interop_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 5768))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^20.3.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/rxjs-interop",
	},
	404: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_kaercher_shared-core_kaercher_shared-core"), __webpack_require__.e("default-webpack_sharing_consume_default_kaercher_payment-methods-core_kaercher_payment-methods-core"), __webpack_require__.e("default-node_modules_ngrx_effects_fesm2022_ngrx-effects_mjs"), __webpack_require__.e("default-node_modules_ngrx_store_fesm2022_ngrx-store_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_kaercher_payment-attempts-core_kaercher_payment-attem-f5bfaa"), __webpack_require__.e("default-webpack_sharing_consume_default_kaercher_payment-attempts-feature_kaercher_payment-at-9b8b51"), __webpack_require__.e("default-webpack_sharing_consume_default_kaercher_paypal-core_kaercher_paypal-core-webpack_sha-b3c35d"), __webpack_require__.e("default-libs_paypal_feature_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @kaercher/paypal-feature */ 6366))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@kaercher/paypal-feature",
	},
	3436: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_kaercher_shared-core_kaercher_shared-core"), __webpack_require__.e("default-node_modules_ngrx_effects_fesm2022_ngrx-effects_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_kaercher_payment-attempts-core_kaercher_payment-attem-f5bfaa"), __webpack_require__.e("default-webpack_sharing_consume_default_kaercher_payment-attempts-infrastructure_kaercher_pay-11766d"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @kaercher/payment-attempts-feature */ 2682))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@kaercher/payment-attempts-feature",
	},
	9857: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_kaercher_shared-core_kaercher_shared-core"), __webpack_require__.e("default-webpack_sharing_consume_default_kaercher_payment-methods-core_kaercher_payment-methods-core"), __webpack_require__.e("default-node_modules_ngrx_effects_fesm2022_ngrx-effects_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_kaercher_payment-attempts-core_kaercher_payment-attem-f5bfaa"), __webpack_require__.e("default-webpack_sharing_consume_default_kaercher_paypal-feature_kaercher_paypal-feature"), __webpack_require__.e("default-webpack_sharing_consume_default_kaercher_shared-ui_kaercher_shared-ui"), __webpack_require__.e("default-libs_payment-methods_feature_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @kaercher/payment-methods-feature */ 9338))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@kaercher/payment-methods-feature",
	},
	6416: {
		getter: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @kaercher/output-events-core */ 3689))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@kaercher/output-events-core",
	},
	1868: {
		getter: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @kaercher/payment-attempts-core */ 6382))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@kaercher/payment-attempts-core",
	},
	6660: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_kaercher_shared-infrastructure_kaercher_shared-infras-452932"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @kaercher/payment-attempts-infrastructure */ 2057))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@kaercher/payment-attempts-infrastructure",
	},
	4980: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_kaercher_shared-core_kaercher_shared-core"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("default-libs_shared_infrastructure_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @kaercher/shared-infrastructure */ 9351))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@kaercher/shared-infrastructure",
	},
	802: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_ngx-translate_core_dist_fesm2022_ngx-translate-core_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @kaercher/shared-ui */ 2794))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@kaercher/shared-ui",
	},
	8156: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_ngx-translate_core_dist_fesm2022_ngx-translate-core_mjs"), __webpack_require__.e("default-node_modules_angular_forms_fesm2022_forms_mjs"), __webpack_require__.e("default-libs_payment-methods_ui_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @kaercher/payment-methods-ui */ 3544))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@kaercher/payment-methods-ui",
	},
	3140: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_kaercher_shared-infrastructure_kaercher_shared-infras-452932"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @kaercher/payment-methods-infrastructure */ 8009))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@kaercher/payment-methods-infrastructure",
	},
	7078: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_kaercher_offline-ui_kaercher_offline-ui"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @kaercher/offline-feature */ 6192))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@kaercher/offline-feature",
	},
	3780: {
		getter: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @kaercher/paypal-core */ 4645))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@kaercher/paypal-core",
	},
	9636: {
		getter: () => (__webpack_require__.e("default-libs_paypal_infrastructure_src_index_ts").then(() => (() => (__webpack_require__(/*! @kaercher/paypal-infrastructure */ 2181))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@kaercher/paypal-infrastructure",
	},
	9782: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_ngx-translate_core_dist_fesm2022_ngx-translate-core_mjs"), __webpack_require__.e("default-node_modules_angular_forms_fesm2022_forms_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_kaercher_shared-ui_kaercher_shared-ui"), __webpack_require__.e("default-libs_paypal_ui_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @kaercher/paypal-ui */ 7124))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@kaercher/paypal-ui",
	},
	3389: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_observable_innerFrom_js-node_modules_rxjs_dist_es-f32a11"), __webpack_require__.e("default-node_modules_angular_common_fesm2022_http_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 4485))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^20.3.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/common/http",
	},
	6174: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_kaercher_paypal-feature_kaercher_paypal-feature"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @kaercher/output-events-feature */ 6402))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@kaercher/output-events-feature",
	},
	2734: {
		getter: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @kaercher/environment */ 9743))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@kaercher/environment",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"default-webpack_sharing_consume_default_angular_core_angular_core": [
		1961
	],
	"default-node_modules_angular_core_fesm2022_resource_mjs": [
		1653,
		6077
	],
	"default-webpack_sharing_consume_default_angular_common_angular_common": [
		4963
	],
	"default-webpack_sharing_consume_default_kaercher_shared-core_kaercher_shared-core": [
		4100
	],
	"default-webpack_sharing_consume_default_kaercher_payment-methods-core_kaercher_payment-methods-core": [
		8828
	],
	"default-webpack_sharing_consume_default_kaercher_offline-ui_kaercher_offline-ui": [
		4204
	],
	"default-node_modules_rxjs_dist_esm_internal_BehaviorSubject_js-node_modules_rxjs_dist_esm_int-5e4f57": [
		917
	],
	"default-webpack_sharing_consume_default_kaercher_paypal-feature_kaercher_paypal-feature": [
		404
	],
	"default-webpack_sharing_consume_default_kaercher_payment-attempts-feature_kaercher_payment-at-9b8b51": [
		3436
	],
	"default-webpack_sharing_consume_default_kaercher_output-events-core_kaercher_output-events-co-1f2e00": [
		9857,
		6416
	],
	"default-webpack_sharing_consume_default_kaercher_payment-attempts-core_kaercher_payment-attem-f5bfaa": [
		1868
	],
	"default-webpack_sharing_consume_default_kaercher_payment-attempts-infrastructure_kaercher_pay-11766d": [
		6660
	],
	"default-webpack_sharing_consume_default_kaercher_shared-infrastructure_kaercher_shared-infras-452932": [
		4980
	],
	"default-webpack_sharing_consume_default_kaercher_shared-ui_kaercher_shared-ui": [
		802
	],
	"default-libs_payment-methods_feature_src_index_ts": [
		8156,
		3140
	],
	"default-libs_payment-methods_ui_src_index_ts": [
		7078
	],
	"default-webpack_sharing_consume_default_kaercher_paypal-core_kaercher_paypal-core-webpack_sha-b3c35d": [
		3780,
		9636
	],
	"default-libs_paypal_feature_src_index_ts": [
		9782
	],
	"default-webpack_sharing_consume_default_angular_common_http_angular_common_http": [
		3389
	],
	"__federation_expose_web_components": [
		6174,
		2734
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}